import dayjs from "dayjs";
import { orgToday } from "@/lib/tz";

export const DT = "YYYY-MM-DD HH:mm:ss";

export const fmtTime = (v) => (v ? dayjs(v).format("h:mm A") : "—");
export const fmtDate = (v) => (v ? dayjs(v).format("ddd D MMM") : "—");
export const fmtDateLong = (v) => (v ? dayjs(v).format("dddd D MMMM YYYY") : "—");
// DEPRECATED for system timestamps (created/updated/applied/signed...): this
// renders the string as-is in browser time. Use fmtLog* from "@/lib/tz".
export const fmtDateTime = (v) => (v ? dayjs(v).format("D MMM, h:mm A") : "—");

// Today's calendar date (YYYY-MM-DD) in the ORG timezone (General settings).
export const todayISO = () => orgToday();

export function mondayOf(d) {
  const day = dayjs(d);
  return day.subtract((day.day() + 6) % 7, "day").startOf("day");
}

// Pay fortnight runs Friday -> Thursday. Seed fortnight start: Fri 2026-08-07.
export const FORTNIGHT_SEED = dayjs("2026-08-07");

export function fridayOf(d) {
  const day = dayjs(d);
  return day.subtract((day.day() - 5 + 7) % 7, "day").startOf("day");
}

export function periodStart(d, fortnightly) {
  const wk = fridayOf(d);
  if (!fortnightly) return wk;
  const weeks = wk.diff(FORTNIGHT_SEED, "week");
  return (weeks % 2 !== 0) ? wk.subtract(7, "day") : wk;
}

export function periodDays(start, fortnightly) {
  const n = fortnightly ? 14 : 7;
  return Array.from({ length: n }, (_, i) => dayjs(start).add(i, "day"));
}

export function weekDays(monday) {
  return Array.from({ length: 7 }, (_, i) => dayjs(monday).add(i, "day"));
}

export function roundQuarter(v) {
  if (!v) return null;
  const d = dayjs(v);
  const mins = d.hour() * 60 + d.minute();
  const rounded = Math.round(mins / 15) * 15;
  return d.startOf("day").add(rounded, "minute");
}

export function diffHours(a, b) {
  if (!a || !b) return 0;
  return Math.max(0, dayjs(b).diff(dayjs(a), "minute") / 60);
}
